import { render } from "./topbar.vue?vue&type=template&id=1d4b4650&scoped=true"
import script from "./topbar.vue?vue&type=script&lang=js"
export * from "./topbar.vue?vue&type=script&lang=js"

import "./topbar.vue?vue&type=style&index=0&id=1d4b4650&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d4b4650"]])

export default __exports__